import type { SidePanelStateContent } from "./side-panel.type";

import { useSetAtom } from "jotai";

import { sidePanelAtom } from "./side-panel.state";

export const useSidePanel = () => {
  const setSidePanel = useSetAtom(sidePanelAtom);

  const openSidePanel = (content: SidePanelStateContent) => {
    setSidePanel({ visible: true, ...content });
  };

  const closeSidePanel = () => {
    setSidePanel({ visible: false });
  };

  return {
    openSidePanel,
    closeSidePanel,
  };
};
